/**
 * Central Feature Flags Configuration
 * Automatically synchronized with backend via X-Chat-Enabled response header & GET /api/front/feature-flags
 * Controlled directly by `ENABLE_CHAT=true/false` in `vivashribackend/.env`!
 */

export let IS_CHAT_ENABLED = true;

// Install universal fetch interceptor to sync chat status on EVERY API response
if (typeof window !== "undefined" && !window.__CHAT_INTERCEPTOR_INSTALLED__) {
  window.__CHAT_INTERCEPTOR_INSTALLED__ = true;
  try {
    localStorage.removeItem("IS_CHAT_ENABLED");
  } catch (_) {}

  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await originalFetch.apply(this, args);
    try {
      const headerVal = res.headers && res.headers.get("x-chat-enabled");
      if (headerVal !== null) {
        IS_CHAT_ENABLED = headerVal === "true";
      }
    } catch (_) {}
    return res;
  };
}

export const initFeatureFlags = async () => {
  try {
    const baseUrl = (process.env.REACT_APP_BASE_URL_API || "").replace(/\/+$/, "");
    if (!baseUrl) return IS_CHAT_ENABLED;

    const res = await fetch(`${baseUrl}/api/front/feature-flags`);
    if (res.ok) {
      const data = await res.json();
      if (data?.status && typeof data?.chat_enabled === "boolean") {
        IS_CHAT_ENABLED = data.chat_enabled;
      }
    }
  } catch (err) {
    // Fail-safe silently if offline
  }
  return IS_CHAT_ENABLED;
};